import { customAxios } from '../../common/customAxios';
import { RegionHierarchy } from '../../../store/userJoinSlice';

interface IPostSignUpParams {
  reqBody: {
    signUpToken: string;
    advertisementTermsAgreement: boolean;
    marketingTermsAgreement: boolean;
    residence: RegionHierarchy;
    job: string;
    extraInfoOfJob?: {
      infoType: string;
      infoValue: string;
    }[];
    joinReason: string;
    joinReasonEtc: string;
    ownTractor: string | null;
    purchaseTractorYn: string | null;
  };
}

interface IPostSignUpResponseData {
  accessToken: string;
}

export const postSignUp = ({ reqBody }: IPostSignUpParams): Promise<IPostSignUpResponseData> => {
  return customAxios.post('/auth/sign-up', reqBody);
};
